function average(values) {
    if (!values.length)
        return null;
    return Math.round(values.reduce((a, b) => a + b, 0) / values.length);
}
/** 集計・出力画面の数値。確定済みHTMLの statsData() と同一の定義。 */
export function dailyStats(all) {
    const count = (f) => all.filter((c) => Boolean(f(c))).length;
    return {
        total: all.length,
        confirm: count((c) => c.clerk?.type === 'confirm'),
        change: count((c) => c.clerk?.type === 'change'),
        stop: count((c) => c.clerk?.type === 'stop'),
        start: count((c) => c.pharm),
        made: count((c) => c.pharmDone),
        admin: count((c) => c.admin),
        done: count((c) => c.adminDone),
        rp: all.filter((c) => c.pharm).reduce((a, c) => a + (c.rpCount || 1), 0),
        toStartMin: average(all
            .filter((c) => c.clerk && c.pharm)
            .map((c) => ((c.pharm?.at ?? 0) - (c.clerk?.at ?? 0)) / 60000)),
        toAdminMin: average(all
            .filter((c) => c.pharm && c.admin)
            .map((c) => ((c.admin?.at ?? 0) - (c.pharm?.at ?? 0)) / 60000)),
    };
}
/** 時間帯ごとの確定件数。10時前後の集中を見るためのもの。 */
export function confirmsByHour(all, toHour, minHour = 8, maxHour = 17) {
    const stamped = all.filter((c) => c.clerk).map((c) => toHour(c.clerk?.at ?? 0));
    const h0 = Math.min(minHour, ...stamped);
    const h1 = Math.max(maxHour, ...stamped);
    const hours = Array.from({ length: h1 - h0 + 1 }, (_, i) => i + h0);
    const counts = hours.map((h) => stamped.filter((x) => x === h).length);
    return { hours, counts };
}
//# sourceMappingURL=stats.js.map